<div [style.zIndex]="zIndex" class="recipient-item flex-row">
  <div class="recipient-badge">
    {{ item.organisation?.orgCode }}
  </div>
  <div class="recipient-content flex-1">
    <ng-container>
      <div class="flex-row">
        <div class="label-span flex-1">
          <label>{{ "organisation.communication.to" | translate }}</label>
          <span><b [innerHTML]="toRecipients"></b></span>
        </div>
      </div>
      @if (ccRecipients) {
        <div class="flex-row">
          <div class="label-span flex-1">
            <label>CC:</label>
            <span [innerHTML]="ccRecipients"></span>
          </div>
        </div>
      }
      @if (bccRecipients) {
        <div class="flex-row">
          <div class="label-span flex-1">
            <label>BCC:</label>
            <span [innerHTML]="bccRecipients"></span>
          </div>
        </div>
      }
    </ng-container>

    <div class="flex-1 recipient-buttons recipient-buttons--scheduled">
      <!--			<button
      (click)="viewMail()"
      class="icon-button"
      matTooltip="{{'clusters.item.viewMail' | translate}}"
      type="button">
      <fa-icon [icon]="['fas', 'magnifying-glass']"></fa-icon>
    </button>-->
  </div>
</div>
</div>
